import { object, string } from "yup";

export const svbConnectSchema = object({
  username: string().required("Username is required"),
  pin: string().required("PIN is required"),
});
